
  import { Component, Prop, Vue } from 'vue-property-decorator'

  import { API } from '@/api/API'
  import NavigateBack from '@/components/elements/NavigateBack.vue'
  import Price from '@/components/elements/Price.vue'
  import EventsList from '@/components/events/EventsList.vue'
  import { environment } from '@/helpers/Environment'
  import { fetchOrderSessions, getMyOrder, getSessionDetails } from '@/helpers/OrderSessionHelpers'

  @Component({
    components: { EventsList, NavigateBack, Price },
  })
  export default class OrderDetailRoute extends Vue {
    @Prop({ required: true })
    id: string

    environment() {
      return environment
    }

    // TODO: Remove these config options once we have confidence in this in production
    enabled: boolean = environment.config.my_account_pages?.recent_orders ?? false

    loading: boolean = false
    showEmailSentMessage: boolean = false
    order: RecentOrder | null = null
    sessions: SessionRow[] | null = null

    async created() {
      this.loading = true
      try {
        const response = await fetchOrderSessions(this.id)

        const [order, sessions] = await Promise.all([getMyOrder(response, this.id), getSessionDetails(response)])

        this.order = order
        this.sessions = sessions
      } finally {
        this.loading = false
      }
    }

    get showResendLink() {
      return this.sessions!.some((session) => session.isUpcoming)
    }

    resendTickets() {
      this.loading = true
      API.post(`ticket_order/${this.id}/email`, { body: {} })
        .then(() => {
          this.showEmailSentMessage = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
